import type {FeeSize, OnBehalfOf} from "../cancelbookingAdminState/cancelBookingAdminState.types";
import {SetIsConfirmed, Next} from "./actions";

export type ConfirmCancellationAdminActions = SetIsConfirmed | Next;

export const confirmCancellationAdminActions = [SetIsConfirmed, Next] as const;

export type confimCancellationAdminStateActions = (typeof confirmCancellationAdminActions)[number];

export interface ConfirmCancellationAdminStateDependencies {
  cancellationFeeSize: FeeSize;
  shouldCloseTime: boolean;
  cancelOnBehalfOf: OnBehalfOf;
  shouldSendCustomerMessages: boolean;
  shouldSendPartnerMessages: boolean;
  cancelReason: string;
}

export interface IGetData {
  cancellationFeeSize: FeeSize;
  shouldCloseTime: boolean;
  cancelOnBehalfOf: OnBehalfOf;
  shouldSendCustomerMessages: boolean;
  shouldSendPartnerMessages: boolean;
  cancelReason: string;

  isConfirmed: boolean;
}
